import SidebarPaginator from './SidebarPaginator';

export default SidebarPaginator;
